var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMessages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 54,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M10.78 28.008c-.536 1.532-.693 3.173-.693 4.782 0 9.325 7.56 16.884 16.884 16.884h8.146c.87 0 1.72-.07 2.55-.196l4.51 2.24c1.905.947 4.1-.607 3.84-2.719l-.37-3.011A16.853 16.853 0 0 0 52 32.79c0-9.168-7.308-16.63-16.416-16.877l-.025-.001h-.025l-8.576.194c-7.7.005-13.859 5.275-16.179 11.901Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__a)",
  d: "M26.97 17.106c-7.22 0-13.044 4.944-15.246 11.232-.485 1.385-.637 2.9-.637 4.452 0 8.773 7.111 15.884 15.884 15.884h8.146c.923 0 1.827-.083 2.708-.234l4.796 2.382c1.193.592 2.565-.38 2.403-1.7l-.44-3.578c3.894-2.895 6.417-7.53 6.417-12.754 0-8.625-6.875-15.644-15.443-15.878l-8.587.194Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__b)",
  d: "m44.584 45.544.44 3.577c.163 1.321-1.21 2.293-2.403 1.7l-4.797-2.381c-.88.15-1.783.233-2.707.233h-3.06L11.72 28.337l-.002.005C13.6 22.05 19.743 17.106 26.97 17.106l8.586-.194a15.836 15.836 0 0 1 10.791 4.646A15.838 15.838 0 0 1 51 32.79c0 5.225-2.523 9.86-6.416 12.754Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__c)",
  d: "M49.915 38.566H12.17c2.31 5.917 8.066 10.108 14.8 10.108h8.146c.924 0 1.828-.083 2.708-.234l4.797 2.382c1.192.592 2.565-.38 2.402-1.7l-.44-3.578a15.933 15.933 0 0 0 5.332-6.978Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__d)",
  d: "M14.249 0h7.307c7.87 0 14.25 6.38 14.25 14.249 0 .91-.086 1.8-.25 2.663-1.247 6.597-7.04 11.486-14 11.486H14.25c-.829 0-1.64.025-2.43-.11l-4.302 2.137c-1.07.531-2.302-.34-2.156-1.526l.395-3.209A14.227 14.227 0 0 1 0 14.25C0 6.379 6.38 0 14.249 0Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__e)",
  d: "M.813 19a14.284 14.284 0 0 0 4.943 6.69l-.394 3.21c-.146 1.185 1.086 2.056 2.155 1.525l4.303-2.137c.79.135 1.6.11 2.43.11h7.307c6.203 0 11.38-3.865 13.336-9.398H.813Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M34.574 16.726c-1.158 6.123-6.538 10.672-13.018 10.672h-7.658c-.718.003-1.32.005-1.91-.096l-.32-.055-.293.145-4.303 2.137.445.896-.445-.896a.5.5 0 0 1-.718-.508l.394-3.209.071-.577-.467-.347A13.227 13.227 0 0 1 1 14.249C1 6.932 6.932 1 14.249 1h7.307c7.317 0 13.25 5.932 13.25 13.249 0 .848-.08 1.676-.232 2.477Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__f)",
  d: "M25.661 15.585a2.784 2.784 0 1 0 0-5.569 2.784 2.784 0 0 0 0 5.57Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__g)",
  d: "M17.903 15.585a2.784 2.784 0 1 0 0-5.569 2.784 2.784 0 0 0 0 5.57Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__h)",
  d: "M10.145 15.585a2.784 2.784 0 1 0 0-5.569 2.784 2.784 0 0 0 0 5.57Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__i)",
  d: "M38.802 36.422a2.784 2.784 0 1 0 0-5.568 2.784 2.784 0 0 0 0 5.569Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__j)",
  d: "M31.043 36.422a2.784 2.784 0 1 0 0-5.568 2.784 2.784 0 0 0 0 5.569Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__k)",
  d: "M23.285 36.422a2.784 2.784 0 1 0 0-5.568 2.784 2.784 0 0 0 0 5.569Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__l)",
  d: "M35.556 16.913a16.08 16.08 0 0 0-.44-.006H26.97c-7.226 0-13.325 4.826-15.25 11.43l.1-.049c.79.136 1.6.21 2.43.21h7.306c6.96 0 12.752-4.989 14-11.585Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__m)",
  d: "M52.836 11.234h-5.07v-5.07c0-.643-.521-1.164-1.164-1.164h-8.203c-.644 0-1.165.521-1.165 1.164v5.07h-5.07c-.643 0-1.164.521-1.164 1.165V20.6c0 .644.521 1.165 1.164 1.165h5.07v5.07c0 .643.521 1.164 1.164 1.164h8.203c.644 0 1.165-.521 1.165-1.165v-5.069h5.07c.643 0 1.164-.521 1.164-1.164v-8.203c0-.644-.521-1.165-1.164-1.165Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M33.5 11.234h3.734v-5.07c0-.643.521-1.164 1.164-1.164h8.203c.644 0 1.165.521 1.165 1.164v5.07h5.07c.643 0 1.164.521 1.164 1.165v8.203c0 .643-.521 1.164-1.164 1.164h-5.07"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__n)",
  d: "M38.512 26.722v-6.234h-6.234v-7.976h6.234V6.278h7.977v6.234h6.234v7.976h-6.234v6.234h-7.977Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__o)",
  d: "M52.836 11.234h-5.07v-5.07c0-.643-.521-1.164-1.164-1.164H42.5v23h4.102c.643 0 1.164-.521 1.164-1.164v-5.07h5.07c.643 0 1.164-.521 1.164-1.164v-8.203c0-.644-.521-1.165-1.164-1.165Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__p)",
  d: "M52.836 11.234h-5.07v-5.07c0-.643-.521-1.164-1.164-1.164H42.5v23h4.102c.643 0 1.164-.521 1.164-1.164v-5.07h5.07c.643 0 1.164-.521 1.164-1.164v-8.203c0-.644-.521-1.165-1.164-1.165Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#messages_svg__q)",
  d: "M31 16.5v4.102c0 .643.521 1.164 1.164 1.164h5.07v5.07c0 .643.521 1.164 1.164 1.164h8.203c.644 0 1.165-.521 1.165-1.165v-5.069h5.07c.643 0 1.164-.521 1.164-1.164V16.5H31Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__a",
  x1: 31.044,
  x2: 31.044,
  y1: 22.205,
  y2: 43.265,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA2AF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A636FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__b",
  x1: 41.568,
  x2: 21.478,
  y1: 37.484,
  y2: 17.394,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A11FE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B0EFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__c",
  x1: 31.043,
  x2: 31.043,
  y1: 40.638,
  y2: 48.929,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__d",
  x1: 9.06,
  x2: 30.323,
  y1: 1.498,
  y2: 35.339,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#988FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.833,
  stopColor: "#5548F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__e",
  x1: 17.853,
  x2: 17.853,
  y1: 20.267,
  y2: 28.469,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4071F7",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30569F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__f",
  x1: 27.2,
  x2: 23.248,
  y1: 11.262,
  y2: 15.214,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__g",
  x1: 19.442,
  x2: 15.489,
  y1: 11.262,
  y2: 15.214,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__h",
  x1: 11.684,
  x2: 7.731,
  y1: 11.262,
  y2: 15.214,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__i",
  x1: 40.341,
  x2: 36.388,
  y1: 32.099,
  y2: 36.052,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__j",
  x1: 32.582,
  x2: 28.63,
  y1: 32.099,
  y2: 36.052,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__k",
  x1: 24.824,
  x2: 20.872,
  y1: 32.099,
  y2: 36.052,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__l",
  x1: 23.638,
  x2: 23.638,
  y1: 19.734,
  y2: 30.165,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AA74D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5609B8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__m",
  x1: 37.587,
  x2: 56.322,
  y1: 11.587,
  y2: 30.322,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#92F37F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4AB272"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__n",
  x1: 44.449,
  x2: 34.019,
  y1: 18.624,
  y2: 7.252,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FED05A",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFEE83"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__o",
  x1: 43.937,
  x2: 36.366,
  y1: 21.081,
  y2: 35.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4AB272",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009245"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__p",
  x1: 43.131,
  x2: 27.893,
  y1: 14.309,
  y2: -2.558,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4AB272",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009245"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "messages_svg__q",
  x1: 41.499,
  x2: 31.271,
  y1: 17.161,
  y2: 1.214,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4AB272",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009245"
})))));
export { SvgMessages as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMmE5ZGU3MGJkNGI4MWZkZTZkMjAzZjU5ODU1MmEyNDQuc3ZnIjs=";